import { useState } from "react";
import styles from "./styles.module.scss";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";

const TextInput = ({
  label,
  isDarkMode,
  name,
  type,
  placeholder,
  value,
  onChnage,
  customClass,
  textarea,
  compolsory,
  height,
  padding,
  className,
  ...props
}) => {
  const [isClick, setIsClick] = useState(false);
  const REGEX = /^[+][(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]$/g;

  return (
    <div
      className={`${isDarkMode ? styles.formInputDark : styles.formInput} ${
        customClass ? customClass : " "
      } `}
      {...props}
    >
      <label>
        {label}
        {compolsory && (
          <span
            style={{
              color: "red",
              textDecoration: "none",
              position: "relative",
              display: "initial",
            }}
          >
            *
          </span>
        )}
      </label>
      {textarea ? (
        <textarea
          name={name}
          value={value}
          placeholder={placeholder}
          type={isClick ? "text" : type}
          min={type === "number " ? "0" : ""}
          className={`text-input ${className}`}
          {...props}
          style={{ color: "#666" }}
        ></textarea>
      ) : (
        <input
          {...props}
          name={name}
          value={value}
          placeholder={placeholder}
          type={isClick ? "text" : type}
          style={{ paddingLeft: padding,color:"#666",background:"#262626" ,
borderTop:' 1px solid #4D4D4D',border:"none"
          }}
          className={`text-input ${className}`}
          // onChnage={onChnage}
        />
      )}
      {type === "password" && (
        <div className={styles.showPass} onClick={() => setIsClick(!isClick)}>
          {isClick ? <AiOutlineEye /> : <AiOutlineEyeInvisible />}
        </div>
      )}
    </div>
  );
};

export default TextInput;
